import PublicThemes from '@/pages/publicPages/PublicThemes/PublicThemes';
import PublicThemesSSP from '@/pages/publicPages/PublicThemes/PublicThemes.ssp';
import PageSEO from '@/shared/PageSEO/PageSEO';

export default function Themes(props) {
  return (
    <>
      <PageSEO
        title="Spanish Learning Themes for Kids | Rockalingua"
        description="All the Rockalingua content organized by subject - theme"
      />
      <PublicThemes {...props.pageProps} />
    </>
  );
}

export const getServerSideProps = async (context) =>
  await PublicThemesSSP({ context });
